import React, { useState, useEffect } from "react";
import "../style/page/Members.css";
import "../style/component/MembersGrid.css";
import { useLogoStripCarousel } from "../hooks/websiteHooks";
import { useTranslation } from "../contexts/TranslationContext";
import { useMembersContent } from "../hooks/useMembersContent";
import MembersGrid from "../component/MembersGrid";

function Members() {
  const [showFireworks, setShowFireworks] = useState(true);
  const { currentLanguage } = useTranslation();
  const { title, description, members, metaTitle } = useMembersContent();

  // Initialize members carousel functionality
  useLogoStripCarousel();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFireworks(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  // Update page title when content changes
  useEffect(() => {
    if (metaTitle) {
      document.title = metaTitle;
    }
  }, [metaTitle]);

  return (
    <>
      {/* Hiệu ứng pháo hoa */}
      {showFireworks && (
        <div className="fireworks-container">
          <div className="firework"></div>
          <div className="firework"></div>
          <div className="firework"></div>
          <div className="firework"></div>
          <div className="firework"></div>
          <div className="firework"></div>
          <div className="firework"></div>
          <div className="firework"></div>
          <div className="firework"></div>
          <div className="firework"></div>
        </div>
      )}

      <main className="main-content members-page">
        <h4 className="page-title">{title}</h4>

        <p className="description">{description}</p>

        <MembersGrid members={members} currentLanguage={currentLanguage} />
      </main>
    </>
  );
}

export default Members;
